;$(function() {

	var page = {};
	page.button 	= $('.menu-burger');
	page.menu 	= $('.header__mobile-menu');

	var action 			= {};
	action.button 		= {};
	action.menu 		= {};
	action.menu.isShown = false;
	action.menu.show 	= () => page.menu.addClass('menu_shown');
	action.menu.hide 	= () => page.menu.removeClass('menu_shown');
	action.button.show 	= () => page.button.addClass('menu-burger_active');
	action.button.hide 	= () => page.button.removeClass('menu-burger_active');
	action.button.click = e => {
		e.preventDefault();
		e.stopImmediatePropagation();

		if (action.menu.isShown) {
			action.button.hide();
			action.menu.hide();
		} else {
			action.button.show();
			action.menu.show();
		}

		action.menu.isShown = !action.menu.isShown;
	}

	page.button.click(action.button.click);
	page.menu.find('button').click(() => page.button.trigger('click'));

	$(document).click(e => {
		if (
			!action.menu.isShown
			|| $(e.target).parent().hasClass('menu-burger')
			|| $(e.target).parents('.header__side-menu').length
			|| $(e.target).hasClass('menu__link_submenu')
		) {
			return;
		}

		page.button.trigger('click');
	});

	$(window).resize(() => {
		if (action.menu.isShown) page.button.trigger('click');
	});

});